import React from "react";
import { useAuth } from "@syos-music/auth";

export default function LogoutPage({ redirect }) {
  const { logout } = useAuth();

  const once = React.useRef();
  React.useEffect(() => {
    if (once.current) return;
    once.current = true;

    logout({ redirect: "/" });
  }, [logout]);

  return null;
}
